'use strict';

var $ = require('dibs-jquery-shim');
var modals = require('./widgets/modals');

$(document).ready(function() {
    // --------------------- //
    // BROWSER COMPATIBILITY //
    // --------------------- //

    // Here we check to see if the users browser is compatible with the admin tools
    // For now, only IE 7 and below are incompatible with the new dealer admin tools
    // So we test for that and display an info modal, then exit further code execution
    // by throwing an error.
    if ($('html').hasClass('lt-ie10') && !$.cookie('has_seen_browser_warning')) {
        modals.infoModal(
            'YOUR BROWSER IS UNSUPPORTED',
            "<p>We're sorry but " +
                'it appears that you are using an older browser that 1stdibs no longer supports. To improve your ' +
                ' experience please upgrade to a new version or use another browser.</p>' +
                '<p>A list of the most popular, updated, and free browsers can be found below:</p>' +
                '<div class="browser-icons row clearfix">' +
                '<div class="browser col-xs-3">' +
                '<a href="http://www.apple.com/safari/"><img src="/img/browser-icons/safari.png" /></a>' +
                '<p>Safari<br /><a href="http://www.apple.com/safari/">LEARN MORE</a></p>' +
                '</div>' +
                '<div class="browser col-xs-3">' +
                '<a href="http://www.firefox.com/"><img src="/img/browser-icons/firefox.png" /></a>' +
                '<p>Firefox<br /><a href="http://www.firefox.com/">LEARN MORE</a></p>' +
                '</div>' +
                '<div class="browser col-xs-3">' +
                '<a href="http://www.google.com/chrome"><img src="/img/browser-icons/chrome.png" /></a>' +
                '<p>Chrome<br /><a href="http://www.google.com/chrome">LEARN MORE</a></p>' +
                '</div>' +
                '<div class="browser col-xs-3">' +
                '<a href="http://windows.microsoft.com/ie"><img src="/img/browser-icons/ie.png" /></a>' +
                '<p>Internet Explorer<br /><a href="http://windows.microsoft.com/ie">LEARN MORE</a></p>' +
                '</div>' +
                '</div>' +
                '<p>If you decide to continue using this tool, certain pages may not display correctly and ' +
                'certain features may not work.</p>',
            {
                buttonText: 'Continue Anyway',
                afterPopupClose: function() {
                    $.cookie('has_seen_browser_warning', 1, { expires: 1 });
                },
            }
        );
        //throw new Error('Incompatible browser');
    }
});
